<template>
  <LayoutBase :isHideHeader="true">
    <div class="block-cover">
      <div class="page-header-quiz">
        <SWNavButton :size="'small'" @click="prevPage" v-if="isHasPrevPage">Back</SWNavButton>

        <p v-if="!isIntro">Step {{ step }} of {{ totalSteps }}</p>
      </div>

      <div>
        <div class="question">
          <div class="content-box-thehome-second">
            <div class="the-home-second-img" v-if="currentScreen.img">
              <img :src="currentScreen.img" alt="" />
            </div>

            <div class="content-the-home">
              <!-- INTRO -->
              <div v-if="isIntro">
                <p class="the-home-second-paragraf-quiz quiz2-title">
                  {{ currentScreen.title }}
                </p>

                <p class="the-home-second-paragraf-quiz">
                  {{ currentScreen.subtitle }}
                </p>

                <p class="the-home-second-paragraf-quiz quiz2-note">
                  {{ currentScreen.note }}
                </p>

                <SWButton
                  id="btn-start"
                  class="quiz-button"
                  @click="nextPage"
                  variant="primari"
                  size="big"
                  fullWidth
                >
                  {{ currentScreen.cta }}
                </SWButton>
              </div>

              <!-- QUESTIONS -->
              <div v-else>
                <p class="the-home-second-paragraf-quiz">
                  {{ currentScreen.question }}
                </p>

                <SWButton
                  class="quiz-button"
                  v-for="(opt, idx) in currentScreen.options"
                  :key="idx"
                  @click="makeAnswer(currentScreen.id, idx)"
                  variant="secondary"
                  size="big"
                  fullWidth
                >
                  {{ opt }}
                </SWButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LayoutBase>
</template>

<script>
import LayoutBase from '../components/layouts/LayoutBase.vue';
import { SWNavButton, SWButton } from 'sw-ui-kit';

const SCREENS = [
  {
    type: 'intro',
    id: 'intro',
    img: require('../assets/img/ImageQstep1.png'),
    title: 'Why are you tired even after 7–8 hours of sleep?',
    subtitle:
      'In 2 minutes, we’ll help identify what’s really stealing your energy — stress, habits, or sleep rhythm issues.',
    note: 'Based on sleep science & behavioral patterns',
    cta: 'Find my sleep issue',
  },
  {
    type: 'question',
    id: 1,
    img: require('../assets/img/ImageQstep1.png'),
    question: 'When you wake up in the morning, how do you usually feel?',
    options: [
      'Refreshed and ready to start the day',
      'Awake, but low on energy',
      'Tired, even after a full night of sleep',
      'Exhausted and struggling to get out of bed',
    ],
  },
  {
    type: 'question',
    id: 2,
    img: require('../assets/img/ImageQstep2.png'),
    question: 'Which situation best describes your sleep most nights?',
    options: [
      'I fall asleep easily and sleep through the night',
      'I fall asleep easily, but wake up during the night',
      'I struggle to fall asleep, but sleep okay once I do',
      'I struggle to fall asleep and wake up multiple times',
    ],
  },
  {
    type: 'question',
    id: 3,
    img: require('../assets/img/ImageQstep3.png'),
    question: 'What most often interferes with your ability to get truly restful sleep?',
    options: [
      'Stress or anxiety that keeps my mind active',
      'Irregular schedule or late screen time',
      'Physical discomfort or restlessness at night',
      'I’m not sure — I just don’t feel recovered',
    ],
  },
  {
    type: 'question',
    id: 4,
    img: require('../assets/img/ImageQstep4.png'),
    question: 'Which of these patterns sounds most like your typical day?',
    options: [
      'I rely on caffeine to stay focused and productive',
      'My energy drops sharply in the afternoon',
      'I feel mentally foggy and easily irritated',
      'My energy feels stable, but my sleep still doesn’t feel restorative',
    ],
  },
  {
    type: 'question',
    id: 5,
    img: require('../assets/img/ImageQstep5.png'),
    question: 'What is the main result you want to get by improving your sleep?',
    options: [
      'Waking up with steady energy and mental clarity',
      'Better focus, memory, and productivity during the day',
      'Feeling calmer, more emotionally balanced, and less reactive',
      'Understanding the real cause of my sleep issues and how to fix it',
    ],
  },
];

export default {
  components: {
    LayoutBase,
    SWNavButton,
    SWButton,
  },
  data() {
    return {
      page: 0, // 0 = intro
      answers: {}, // {1: 0..3, 2: 0..3 ...}
      dlStartSent: false,
    };
  },
  computed: {
    screens() {
      return SCREENS;
    },
    currentScreen() {
      return this.screens[this.page];
    },
    isIntro() {
      return this.currentScreen?.type === 'intro';
    },
    isHasPrevPage() {
      return this.page !== 0;
    },
    totalSteps() {
      return this.screens.filter(s => s.type === 'question').length; // 5
    },
    step() {
      // page=1 => Step 1
      return this.page;
    },
  },
  methods: {
    makeAnswer(id, optionIndex) {
      this.answers[id] = optionIndex;
      this.nextPage();
    },
    nextPage() {
      // #1: Start click only on intro screen and only once
      if (this.isIntro && !this.dlStartSent) {
        this.dlStartSent = true;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event:'button_click',
            button_name:'start',
            button_location:'hero_section',
            page_url:window.location.href,
          });
        } catch (e) {
          console.warn('dataLayer start button error', e);
        }
      }

      if (this.screens.length !== this.page + 1) {
        this.page += 1;
      } else {
        this.$router.push({ name: 'results2', params: { answers: this.answers } });
      }
    },
    prevPage() {
      this.page -= 1;
    },
  },
};
</script>

<style lang="sass" scoped>
.question
   width: 100%
.quiz-button
   margin-bottom: 15px
   @media screen and (max-width:600px)
      margin-bottom: 0px
      margin-top: 15px
   @media screen and (max-width:380px)
      margin-bottom: 0px
      margin-top: 10px

.content-box-thehome-second
   display: flex
   width: 100%
   justify-content: center
   align-items: center

   @media screen and (max-width: 1100px)
      justify-content: center
      align-items: center
   @media screen and (max-width: 880px)
      flex-direction: column
.page-header-quiz
   display: flex
   align-items: center
   justify-content: center
   width: 100%
   place-self: baseline
   margin-top: 0px
   margin-bottom: 15%
   @media screen and (max-width: 880px)
      margin: 15px 0px 23px 0px

.page-header-quiz p
   white-space: nowrap
   margin: 0 auto
   transform: translateX(-50%)

@media screen and (max-width: 650px)
   .page-header-quiz p:nth-child(1)
      transform: translateX(-8%)

@media screen and (max-width: 380px)
   .the-home-second-paragraf-quiz:nth-child(4)
      margin-bottom: 0px
.btn-header-page
   display: block
.the-home-second-paragraf-quiz
   font-size: 24px
   font-weight: 400
   margin-bottom: 25px
   @media screen and (max-width:900px)
      font-size: 22px
      line-height: 22.5px
   @media screen and (max-width:375px)
      font-size: 22px
      margin-bottom: 15px

.wrapper .content .content-wrapper
   display: block
.page-header-quiz
   font-size: 12px
   font-weight: 400
.content-the-home
   max-width: 439px
   width: 100%
   margin-right: 100px
   @media screen and (max-width: 1100px)
      margin-right: 0px
      margin-top: 50px
   @media screen and (max-width: 480px)
      margin-top: 0px

.the-home-second-title
   font-size: 32px
   font-weight: 700
   margin-bottom: 32px
   @media screen and (max-width: 480px)
      margin-bottom: 20px

.the-home-second-recomeid
   font-size: 12px
   font-weight: 400
   margin-top: 64px
   margin-bottom: 60px
   @media screen and (max-width: 480px)
      font-size: 10px
      margin-top: 18px
      margin-bottom: 55px

.block-cover
   width: 100%
   @media screen and (max-width:880px)
      height: 100%
.the-home-second-img
   max-width: 730px
   width: 100%
   margin-right: 30px

   @media screen and (max-width: 1100px)
      margin: 0 auto
      margin-right: 30px
   @media screen and (max-width: 880px)
      // margin-right: 0
      max-width: 500px
   @media screen and (max-width: 480px)
      margin-bottom: 50px
      margin-top: 25px
   @media screen and (max-width:380px)
      max-width: 280px
      margin-bottom: 20px
      margin-top: 0
</style>
